// extracted by mini-css-extract-plugin
export var ArticleCard = "ArticleCardBlock-module--ArticleCard--d0df3";
export var articleContent = "ArticleCardBlock-module--articleContent--99349";
export var buttonTag = "ArticleCardBlock-module--buttonTag--685e6";
export var capitalize = "ArticleCardBlock-module--capitalize--acb90";
export var date = "ArticleCardBlock-module--date--fef45";
export var dateMobile = "ArticleCardBlock-module--dateMobile--c0549";
export var fs14 = "ArticleCardBlock-module--fs-14--7f179";
export var fs16 = "ArticleCardBlock-module--fs-16--36f66";
export var fs20 = "ArticleCardBlock-module--fs-20--9a0b9";
export var fs24 = "ArticleCardBlock-module--fs-24--a9d47";
export var fs32 = "ArticleCardBlock-module--fs-32--49e72";
export var fs40 = "ArticleCardBlock-module--fs-40--c95b7";
export var fsItalic = "ArticleCardBlock-module--fs-italic--0e3d0";
export var fsLg = "ArticleCardBlock-module--fs-lg--f3427";
export var fsMd = "ArticleCardBlock-module--fs-md--7fdc4";
export var fsNormal = "ArticleCardBlock-module--fs-normal--46438";
export var fsSm = "ArticleCardBlock-module--fs-sm--e8e7e";
export var fsXl = "ArticleCardBlock-module--fs-xl--0c317";
export var fsXs = "ArticleCardBlock-module--fs-xs--03cb8";
export var fsXxl = "ArticleCardBlock-module--fs-xxl--9b39b";
export var fsXxs = "ArticleCardBlock-module--fs-xxs--841cd";
export var fwBold = "ArticleCardBlock-module--fw-bold--f1fca";
export var fwMedium = "ArticleCardBlock-module--fw-medium--668c3";
export var fwNormal = "ArticleCardBlock-module--fw-normal--65275";
export var gotham_bold = "ArticleCardBlock-module--gotham_bold--4bdf0";
export var gotham_bold_italic = "ArticleCardBlock-module--gotham_bold_italic--e246b";
export var gotham_book = "ArticleCardBlock-module--gotham_book--16286";
export var gotham_book_italic = "ArticleCardBlock-module--gotham_book_italic--35f70";
export var icon = "ArticleCardBlock-module--icon--a41c8";
export var iconContainer = "ArticleCardBlock-module--iconContainer--1fc0c";
export var img = "ArticleCardBlock-module--img--c5448";
export var lowercase = "ArticleCardBlock-module--lowercase--ad743";
export var seeMoreButton = "ArticleCardBlock-module--seeMoreButton--7261c";
export var tag = "ArticleCardBlock-module--tag--7f441";
export var tagMobile = "ArticleCardBlock-module--tagMobile--34542";
export var tagsContainer = "ArticleCardBlock-module--tagsContainer--7ea55";
export var tagsMobile = "ArticleCardBlock-module--tagsMobile--8dbd3";
export var tagsSwiper = "ArticleCardBlock-module--tagsSwiper--b36e5";
export var uppercase = "ArticleCardBlock-module--uppercase--aeaf2";